import React from 'react'

export default function Booking() {
  return (
    <div>
      
    </div>
  )
}
